import request from '@/utils/request'
import config from '@/config'
export default {
  getLatestWaterLevel (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetLatestWaterLevel', { params })
  },
  getHourlyRiverLevel (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetHourlyRiverLevel', { params })
  },
  getReservoirImpoundmentInfo (params) {
    return request.get(config.ApiYJ + '/HydrologyCenter/reservoir_impoundment_info', { params })
  },
  // 水库超汛限
  getOverflowWarningWater (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflowWarningWater', { params })
  },
  // 雨量超警
  getOverflowWarningRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetOverflowWarningRain', { params })
  },
  // 水雨情表单导出
  exportRainWaterList (params) {
    return request.post(config.ApiYSQ + '/Export/RainWaterExportRoute', params)
  },
  // 获取异常水文/气象站数据
  getProblematicStation () {
    return request.get(config.ApiYJ + '/monitor/GetProblematicStation')
  },
  // 获得同一站点的多个测站信息
  getAllStationsBystid (params) {
    return request.get(config.ApiYJ + '/HydrologyCenter/GetAllStationsBystid', { params })
  }

}
